import { rowLine, headLine, counts, dupLine, resumeLines } from "../lib/bulkSession";
import { savedTag } from "../lib/photoStep";

// Bulk scan's session UI: the pill under the scan bar, the list sheet it opens, and one item's
// page. All three are overlays on the live camera, so the stream is never torn down.
// Injected like the camera's CSS (dangerouslySetInnerHTML), for the same hydration reason.

const CSS = `
.bp{
  position:absolute; z-index:5; top:calc(env(safe-area-inset-top,0px) + 74px); left:50%; transform:translateX(-50%);
  width:max-content; max-width:calc(100% - 32px); height:44px; box-sizing:border-box; border-radius:22px;
  display:flex; align-items:center; gap:6px; padding:0 10px 0 0; color:#f4f2ee; font-family:system-ui,sans-serif;
  background:rgba(20,19,18,.5); border:1px solid rgba(255,255,255,.14);
  -webkit-backdrop-filter:blur(16px) saturate(1.4); backdrop-filter:blur(16px) saturate(1.4);
}
.bp--green{background:rgba(18,52,32,.62); border-color:rgba(127,214,154,.4);}
.bp--green{animation:bp-in .2s ease-out;}
@keyframes bp-in{from{opacity:0; transform:translateX(-50%) translateY(-6px);} to{opacity:1; transform:translateX(-50%);}}
.bp--amber{background:rgba(70,48,8,.66); border-color:rgba(255,176,32,.4);}
.bp--red{background:rgba(76,22,20,.7); border-color:rgba(255,122,112,.4);}
.bp-main{
  appearance:none; border:0; background:none; font:inherit; color:inherit; cursor:pointer; min-width:0; height:100%;
  display:flex; align-items:center; gap:10px; padding:0 0 0 8px; -webkit-tap-highlight-color:transparent;
  margin:-1px 0; height:calc(100% + 2px);
}
.bp-pic{flex:none; width:28px; height:28px; border-radius:14px; overflow:hidden; background:#3a3936;}
.bp-pic img{width:100%; height:100%; object-fit:cover; display:block;}
.bp-txt{white-space:nowrap; overflow:hidden; text-overflow:ellipsis; min-width:0;}
.bp-txt b{font-size:14px; font-weight:700; letter-spacing:-.1px;}
.bp-txt span{font-size:13px; font-weight:500; color:#a8a39a;}
.bp--green .bp-txt span{color:#a9e6bf;}
.bp--amber .bp-txt span{color:#ffd27a;}
.bp--red .bp-txt span{color:#ff9a90;}
.bp-ring,.bl-ring{
  flex:none; border-radius:50%; background:conic-gradient(#f2b01e 65%,rgba(255,255,255,.2) 0);
  -webkit-mask:radial-gradient(circle,transparent 6.5px,#000 7px); mask:radial-gradient(circle,transparent 6.5px,#000 7px);
  animation:bl-spin 1.1s linear infinite;
}
.bp-ring{width:18px; height:18px;}
.bl-ring{width:20px; height:20px;}
@keyframes bl-spin{to{transform:rotate(360deg);}}
.bp-chev{flex:none; display:inline-flex; color:#a8a39a;}
.bp-retry,.bl-retry{
  appearance:none; border:0; font:inherit; flex:none; cursor:pointer; height:30px; padding:0 12px; border-radius:15px;
  background:#fff; color:#1b1a18; font-size:12px; font-weight:700;
}
.bl-retry{height:32px; border-radius:16px;}

.bl{
  position:absolute; inset:0; z-index:10; display:flex; flex-direction:column; justify-content:flex-end;
  background:rgba(0,0,0,.5); color:#f4f2ee; font-family:system-ui,sans-serif;
}
.bl-sheet{
  position:relative; box-sizing:border-box; width:100%; max-width:560px; margin:0 auto; height:calc(100% - 92px);
  display:flex; flex-direction:column; gap:14px; padding:10px 20px calc(env(safe-area-inset-bottom,0px) + 20px);
  background:#161615; border-radius:24px 24px 0 0; animation:bl-up .2s ease-out;
}
@keyframes bl-up{from{transform:translateY(100%);}to{transform:none;}}
.bl-grab{align-self:center; flex:none; width:36px; height:4px; border-radius:2px; background:#3a3936;}
.bl-head{flex:none; display:flex; align-items:flex-start; justify-content:space-between; gap:12px;}
.bl-head div{display:flex; flex-direction:column; gap:2px; min-width:0;}
.bl-head b{font-size:20px; line-height:26px; font-weight:650;}
.bl-head span{font-size:13px; color:#a8a39a;}
.bl-x,.bl-back{
  appearance:none; border:0; flex:none; width:44px; height:44px; border-radius:22px; cursor:pointer;
  background:rgba(255,255,255,.08); color:inherit; display:inline-flex; align-items:center; justify-content:center;
}
.bl-rows{flex:1 1 auto; min-height:0; overflow-y:auto; display:flex; flex-direction:column;}
.bl-row{
  appearance:none; border:0; background:none; font:inherit; color:inherit; text-align:left; cursor:pointer; flex:none;
  display:flex; align-items:center; gap:12px; padding:10px 0; -webkit-tap-highlight-color:transparent;
}
.bl-pic{flex:none; position:relative; width:52px; height:52px; border-radius:12px; overflow:hidden; background:#3a3936;}
.bl-pic img{width:100%; height:100%; object-fit:cover; display:block;}
.bl-pic--pack{background:linear-gradient(180deg,#fff,#f3f1ec);}
.bl-pic--pack img{object-fit:contain;}
.bl-txt{flex:1; min-width:0; display:flex; flex-direction:column; gap:3px;}
.bl-txt b{font-size:15px; font-weight:600; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}
.bl-txt span{font-size:12px; color:#a8a39a; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;}
.bl-txt i{font-style:normal; color:#d9b45a;}
.bl-txt i.bad{color:#ff8a80;}
.bl-ok{
  flex:none; width:22px; height:22px; border-radius:11px; background:rgba(127,214,154,.14); color:#7fd69a;
  display:inline-flex; align-items:center; justify-content:center;
}
.bl-ok--bad{background:rgba(255,138,128,.16); color:#ff8a80; font-size:13px; font-weight:800;}
.bl-go{flex:none; display:inline-flex; color:#55534e;}
.bl-foot{flex:none; display:grid; grid-template-columns:1fr 1.4fr; gap:10px;}
.bl-btn{white-space:nowrap; 
  appearance:none; border:0; font:inherit; height:52px; border-radius:26px; cursor:pointer; font-size:15px; font-weight:700;
  background:rgba(255,255,255,.1); color:#f4f2ee; -webkit-tap-highlight-color:transparent;
}
.bl-btn--go{background:#f2b01e; color:#1b1a18;}
.bl-btn:disabled{opacity:.75; cursor:default;}
.bl-btn--busy:disabled{opacity:1; background:rgba(242,176,30,.35); display:flex; align-items:center; justify-content:center; gap:10px;}
.bl-ring--dk{width:18px; height:18px; background:conic-gradient(#1b1a18 65%,rgba(27,26,24,.25) 0);}
.bl-prog{flex:none; display:flex; flex-direction:column; gap:8px; padding:12px; border-radius:16px; background:rgba(255,255,255,.05);}
.bl-prog div:first-child{display:flex; justify-content:space-between; font-size:13px;}
.bl-prog div:first-child span{color:#a8a39a; font-variant-numeric:tabular-nums;}
.bl-bar{height:6px; border-radius:3px; background:#2c2b29; overflow:hidden;}
.bl-bar i{display:block; height:100%; background:#f2b01e;}
.bl-prog > span{font-size:12px; color:#a8a39a;}
.bl-item{
  position:absolute; inset:0; z-index:11; box-sizing:border-box; background:#121211; display:flex; flex-direction:column; gap:14px;
  padding:calc(env(safe-area-inset-top,0px) + 16px) 20px calc(env(safe-area-inset-bottom,0px) + 30px); overflow-y:auto;
  animation:bl-in .2s ease-out;
}
@keyframes bl-in{from{opacity:0; transform:translateX(16px);} to{opacity:1; transform:none;}}
.bl-ibar{flex:none; display:grid; grid-template-columns:44px minmax(0,1fr) 44px; align-items:center; margin:0 -4px;}
.bl-ibar .bl-back{width:44px; height:44px; border-radius:22px;}
.bl-ibar div{display:flex; flex-direction:column; align-items:center;}
.bl-ibar b{font-size:15px; line-height:20px; font-weight:600;}
.bl-ibar span{font-size:12px; color:#a8a39a;}
.bl-big{flex:none; align-self:center; width:240px; height:240px; border-radius:24px; overflow:hidden; background:#3a3936;}
.bl-big img{width:100%; height:100%; object-fit:cover; display:block;}
.bl-big--pack{background:linear-gradient(180deg,#fff,#f3f1ec);}
.bl-big--pack img{object-fit:contain;}
.bl-name{flex:none; display:flex; flex-direction:column; gap:2px;}
.bl-name b{font-size:20px; font-weight:650; overflow-wrap:anywhere;}
.bl-name span{font-size:13px; color:#a8a39a;}
.bl-strip{flex:none; display:flex; gap:8px; overflow-x:auto; scrollbar-width:none;}
.bl-strip::-webkit-scrollbar{display:none;}
.bl-t{position:relative; flex:none; width:96px; height:96px; border-radius:14px; overflow:hidden; background:#3a3936;}
.bl-t img{width:100%; height:100%; object-fit:cover; display:block;}
.bl-t--new{box-shadow:inset 0 0 0 2px #f2b01e;}
.bl-t em{
  position:absolute; left:3px; bottom:3px; padding:1px 4px; border-radius:4px; background:rgba(0,0,0,.65);
  color:#fff; font-size:9px; font-weight:700; font-style:normal;
}
.bl-t--new em{background:#f2b01e; color:#1b1a18;}
.bl-acts{margin-top:auto; flex:none; display:flex; flex-direction:column; gap:4px;}
.bl-acts .bl-btn--go{display:block; width:100%;}
.bl-link{appearance:none; border:0; background:none; font:inherit; align-self:center; height:44px; padding:0 12px; font-size:14px; color:#d9d5cd; cursor:pointer;}
.bl-confirm{
  position:absolute; inset:0; z-index:12; background:rgba(0,0,0,.55); display:flex; align-items:center; justify-content:center; padding:24px;
}
.bl-dlg{width:100%; max-width:320px; box-sizing:border-box; padding:20px; border-radius:20px; background:#232220; display:flex; flex-direction:column; gap:8px;}
.bl-dlg b{font-size:17px; font-weight:650;}
.bl-dlg span{font-size:14px; color:#a8a39a; line-height:20px;}
.bl-dlg div{display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-top:10px;}
.bl-dlg .bl-btn{height:44px; border-radius:22px;}
/* The in-between windows: a sheet over the dimmed camera, like the barcode-on-file sheet. */
.bw{
  position:absolute; inset:0; z-index:10; background:rgba(0,0,0,.35); color:#f4f2ee;
  display:flex; flex-direction:column; justify-content:flex-end; font-family:system-ui,sans-serif;
}
.bw-sheet{
  box-sizing:border-box; width:100%; max-width:560px; margin:0 auto; max-height:calc(100% - 120px);
  display:flex; flex-direction:column; gap:14px; padding:10px 20px calc(env(safe-area-inset-bottom,0px) + 24px);
  background:#161615; border-radius:24px 24px 0 0; animation:bl-up .2s ease-out;
}
.bw-head{flex:none; display:flex; flex-direction:column; gap:2px;}
.bw-head b{font-size:20px; line-height:26px; font-weight:650;}
.bw-head span{font-size:13px; line-height:18px; color:#a8a39a;}
.bw-pic{flex:none; align-self:stretch; height:200px; border-radius:18px; overflow:hidden; background:#3a3936;}
.bw-pic img{width:100%; height:100%; object-fit:cover; display:block;}
.bw-pic--pack{background:linear-gradient(180deg,#fff,#f3f1ec);}
.bw-pic--pack img{object-fit:contain;}
.bw-card{flex:none; display:flex; align-items:center; gap:12px; padding:10px 12px; border-radius:16px; background:rgba(255,255,255,.05);}
.bw-shots{flex:none; display:flex; gap:8px; overflow-x:auto; scrollbar-width:none;}
.bw-shots::-webkit-scrollbar{display:none;}
.bw-shots span{flex:none; width:64px; height:64px; border-radius:12px; overflow:hidden; background:#3a3936;}
.bw-shots img{width:100%; height:100%; object-fit:cover; display:block;}
.bw-stack{flex:none; display:flex; padding-left:14px;}
.bw-stack span{width:40px; height:40px; margin-left:-14px; border-radius:10px; overflow:hidden; background:#3a3936; box-shadow:0 0 0 2px #1f1e1d;}
.bw-stack img{width:100%; height:100%; object-fit:cover; display:block;}
.bw-card .bl-txt b{font-size:15px; font-weight:700;}
.bw-card .bl-txt span.ok{color:#7fd69a;}
.bw-card .bl-txt span.bad{color:#ff8a80;}
.bw-gap{flex:1 1 0; min-height:0;}
@media (prefers-reduced-motion:reduce){ .bw-sheet{animation:none;} .bl-sheet{animation:none;} .bp-ring,.bl-ring{animation:none;} .bp--green,.bl-item{animation:none;} }
`;

const Chev = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
);

/** The pill under the scan bar: latest picture, "7 items · 19 photos", a chevron. */
export function BulkPill({ pill, picture, onOpen, onRetry }) {
  return (
    <div className={"bp bp--" + pill.tone} key={pill.tone} role="status">
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <button type="button" className="bp-main" onClick={onOpen} aria-label="Open the list of items scanned">
        <span className="bp-pic">{picture ? <img src={picture} alt="" draggable={false} /> : null}</span>
        <span className="bp-txt">
          <b>{pill.main}</b>
          <span>&nbsp;&middot;&nbsp;{pill.sub}</span>
        </span>
        {pill.ring ? <span className="bp-ring" aria-hidden="true" /> : null}
        {pill.retry ? null : <span className="bp-chev"><Chev /></span>}
      </button>
      {pill.retry ? <button type="button" className="bp-retry" onClick={onRetry}>Retry</button> : null}
    </div>
  );
}

const Pic = ({ item, cls }) => {
  const pack = item.images?.[0]?.kind === "packshot" && item.pictureUrl === item.images[0].url;
  return <span className={cls + (pack ? " " + cls + "--pack" : "")}>{item.pictureUrl ? <img src={item.pictureUrl} alt="" draggable={false} decoding="async" /> : null}</span>;
};

/** Finish is waiting: "Finishing uploads · 17 of 19" over a yellow bar. */
function Finishing({ session }) {
  const c = counts(session);
  return (
    <div className="bl-prog" role="status">
      <div><b>Finishing uploads</b><span>{c.uploaded} of {c.photos}</span></div>
      <div className="bl-bar"><i style={{ width: (c.photos ? Math.round((c.uploaded / c.photos) * 100) : 100) + "%" }} /></div>
      <span>Keep this page open. Cosmos opens when they&rsquo;re in.</span>
    </div>
  );
}

const Window = ({ label, children }) => (
  <div className="bw" role="dialog" aria-modal="true" aria-label={label}>
    <style dangerouslySetInnerHTML={{ __html: CSS }} />
    <div className="bw-sheet">
      <span className="bl-grab" />
      {children}
    </div>
  </div>
);

/** W1: the barcode just read is already in this scan. `dup` is {item, n}. */
export function DuplicateSheet({ dup, onAdd, onDifferent }) {
  const { item, n } = dup;
  const line = rowLine(item);
  return (
    <Window label="Already in this scan">
      <div className="bw-head">
        <b>Already in this scan</b>
        <span>{dupLine(n, item)}</span>
      </div>
      <Pic item={item} cls="bw-pic" />
      <div className="bw-card">
        <Pic item={item} cls="bl-pic" />
        <span className="bl-txt">
          <b>{item.name}</b>
          <span>{line.lead}{line.tail ? <> &middot; <i>{line.tail}</i></> : null}</span>
        </span>
      </div>
      <button type="button" className="bl-btn bl-btn--go" disabled={!item.productId} onClick={() => onAdd(item)}>
        {item.productId ? `Add photos to item ${n}` : "Saving…"}
      </button>
      <button type="button" className="bl-link" onClick={onDifferent}>It&rsquo;s a different item</button>
    </Window>
  );
}

/** W2 and the Quick scan ×: unsaved photos. `onLeave` adds the "Leave Quick scan" link. */
export function DiscardSheet({ title, sub, thumbs, onDiscard, onKeep, onLeave }) {
  return (
    <Window label={title}>
      <div className="bw-head">
        <b>{title}</b>
        <span>{sub}</span>
      </div>
      <div className="bw-shots">{thumbs.map((u, i) => <span key={i}><img src={u} alt="" draggable={false} /></span>)}</div>
      <div className="bl-foot">
        <button type="button" className="bl-btn" onClick={onDiscard}>Discard</button>
        <button type="button" className="bl-btn bl-btn--go" onClick={onKeep}>Keep photographing</button>
      </div>
      {onLeave ? <button type="button" className="bl-link" onClick={onLeave}>Leave Quick scan</button> : null}
    </Window>
  );
}

/** W5: the capture app opened into a bulk scan that is still open. */
export function ResumeSheet({ session, onFinish, onContinue }) {
  const r = resumeLines(session);
  const pics = session.items.slice(-3).map((it) => it.pictureUrl).filter(Boolean);
  return (
    <Window label="Your bulk scan is still open">
      <div className="bw-head">
        <b>Your bulk scan is still open</b>
        <span>{r.sub}</span>
      </div>
      <div className="bw-card">
        {pics.length ? <span className="bw-stack">{pics.map((u, i) => <span key={i}><img src={u} alt="" draggable={false} /></span>)}</span> : null}
        <span className="bl-txt">
          <b>{r.main}</b>
          <span className={r.bad ? "bad" : "ok"}>{r.state}</span>
        </span>
      </div>
      <div className="bw-gap" />
      <div className="bl-foot">
        <button type="button" className="bl-btn" onClick={onFinish}>Finish</button>
        <button type="button" className="bl-btn bl-btn--go" onClick={onContinue}>Continue scanning</button>
      </div>
    </Window>
  );
}

/**
 * The list sheet, and an item's page over it. `view` is "list" or an item key.
 * Newest first. Finish waits for uploads (`finishing`) and the camera decides what follows.
 */
export default function BulkList({ session, view, finishing, confirming, onClose, onOpen, onBack, onRetry, onFinish, onAddMore, onAskRemove, onCancelRemove, onRemove }) {
  const items = session.items;
  const at = view === "list" ? -1 : items.findIndex((it) => it.key === view);
  const item = at >= 0 ? items[at] : null;
  return (
    <div className="bl" role="dialog" aria-modal="true" aria-label={item ? item.name : "Items scanned"}>
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <div className="bl-sheet">
        <span className="bl-grab" />
        <div className="bl-head">
          <div>
            <b>{counts(session).items === 1 ? "1 item" : `${counts(session).items} items`}</b>
            <span>{headLine(session)}</span>
          </div>
          <button type="button" className="bl-x" aria-label="Close" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
          </button>
        </div>
        {finishing ? <Finishing session={session} /> : null}
        <div className="bl-rows">
          {items.slice().reverse().map((it) => {
            const line = rowLine(it);
            return (
              <div key={it.key} className="bl-row" role="button" tabIndex={0} onClick={() => onOpen(it.key)} onKeyDown={(e) => e.key === "Enter" && onOpen(it.key)}>
                <Pic item={it} cls="bl-pic" />
                <span className="bl-txt">
                  <b>{it.name}</b>
                  <span>
                    {line.lead}
                    {line.tail ? <> &middot; <i className={line.state === "failed" ? "bad" : ""}>{line.tail}</i></> : null}
                  </span>
                </span>
                {line.state === "uploading" ? <span className="bl-ring" aria-label="Uploading" />
                  : line.state === "failed" ? (
                    it.uploads.some((u) => u.state === "failed" && !u.lost)
                      ? <button type="button" className="bl-retry" onClick={(e) => { e.stopPropagation(); onRetry(); }}>Retry</button>
                      : <span className="bl-ok bl-ok--bad" aria-label="Did not upload">!</span>
                  ) : (
                    <span className="bl-ok" aria-label="Uploaded">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
                    </span>
                  )}
                <span className="bl-go"><Chev /></span>
              </div>
            );
          })}
        </div>
        <div className="bl-foot">
          <button type="button" className="bl-btn" onClick={onClose}>Keep scanning</button>
          <button type="button" className={"bl-btn bl-btn--go" + (finishing ? " bl-btn--busy" : "")} disabled={finishing} onClick={onFinish}>
            {finishing ? <><span className="bl-ring bl-ring--dk" aria-hidden="true" />Finishing…</> : "Finish"}
          </button>
        </div>
      </div>

      {item ? (
        <div className="bl-item">
          <div className="bl-ibar">
            <button type="button" className="bl-back" aria-label="Back to the list" onClick={onBack}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6" /></svg>
            </button>
            <div>
              <b>Item {at + 1}</b>
              <span>{item.savedAt ? "Saved " + new Date(item.savedAt).toTimeString().slice(0, 5) : "Saving…"}</span>
            </div>
            <span />
          </div>
          <Pic item={item} cls="bl-big" />
          <div className="bl-name">
            <b>{item.name}</b>
            <span>
              {[item.title && item.barcode, item.kind === "catalog" ? "in your catalog" : null, `item ${at + 1} of ${items.length}`].filter(Boolean).join(" · ")}
            </span>
          </div>
          <div className="bl-strip">
            {(item.images || []).map((img, i) => (
              <span className="bl-t" key={"f" + i}>
                <img src={img.url} alt="" draggable={false} loading="lazy" />
                {savedTag(img.kind) ? <em>{savedTag(img.kind)}</em> : null}
              </span>
            ))}
            {(item.thumbs || []).map((t, i) => (
              <span className="bl-t bl-t--new" key={"n" + i}>
                <img src={t} alt="" draggable={false} />
                <em>New</em>
              </span>
            ))}
          </div>
          <div className="bl-acts">
            <button type="button" className="bl-btn bl-btn--go" disabled={!item.productId} onClick={() => onAddMore(item)}>
              {item.productId ? "Add more photos" : "Saving…"}
            </button>
            <button type="button" className="bl-link" onClick={onAskRemove}>Remove this item</button>
          </div>
          {confirming ? (
            <div className="bl-confirm">
              <div className="bl-dlg" role="alertdialog" aria-label="Remove from this scan?">
                <b>Remove from this scan?</b>
                <span>Its photos stay saved in Cosmos.</span>
                <div>
                  <button type="button" className="bl-btn" onClick={onCancelRemove}>Cancel</button>
                  <button type="button" className="bl-btn bl-btn--go" onClick={() => onRemove(item.key)}>Remove</button>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
